/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getMigrationStatus, updateMigrationStatus } from '../../../../../../state/thunks/commenting';
// material
import { SubPage, Copy, BodyCopy, CTAs, Button, displayModal } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './migrationconfirm_styles';

/* ========== ~~~~~~~~~~ MIGRATION CONFIRM ~~~~~~~~~~ ========== */
const MigrationConfirm = props => {

  const dispatch = useDispatch();

  const { commentingUnitUUID } = props

  const [isProcessing, setIsProcessing] = useState(false);

  const handleNo = () => dispatch(displayModal(false));

  const handleYes = () => {
    setIsProcessing(true)
    startMigration()
  }

  const startMigration = useCallback(async() => {
    const response = await dispatch(updateMigrationStatus({commentingUnitUUID, status: 'STARTED'}));
    const newCommentingUnitUUID = response.payload;
    // After successful migration start refetch migration status
    if(newCommentingUnitUUID) {
        dispatch(getMigrationStatus(newCommentingUnitUUID));
        dispatch(displayModal(false));
    }
    setIsProcessing(false)
  }, [commentingUnitUUID, dispatch])


  return (
      <SubPage name={`migrationconfirm`} klass={props.classes.migrationconfirm}>
          <Copy name={`migrationconfirm`}>
              <BodyCopy>{`Are you sure you want to start this migration?`}</BodyCopy>
          </Copy>
          <CTAs name={`ctas`} >
              <Button type={`action`} handleClick={handleNo} variant={`normal`} name={`no`} text={`No`} />
              <Button type={'action'} handleClick={handleYes} variant={`primary`} name={`yes`} text={`Yes`}  
                processing={isProcessing}
                disabled={isProcessing}
                processingText={'Migrating...'}
            />
          </CTAs>
      </SubPage>
  );
};

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(MigrationConfirm);
